import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  DataCollectionApi,
  GrossIncomeRequest,
} from "../../orchestrator-api-client";
import { ThunkApi } from "../store.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitGrossIncome = createAsyncThunk<
  GrossIncomeRequest,
  GrossIncomeRequest,
  ThunkApi
>("submitGrossIncome", async (args, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addGrossIncome(args);

    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio reddito lordo",
      description:
        "Non siamo riusciti a salvare la tua richiesta.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
